import * as dialog from '@zag-js/dialog';
import { normalizeProps, useMachine } from 'zag-ripple';
import { track, Portal } from 'ripple';
import { X } from 'lucide-ripple';

export component Dialog() {
	let service = useMachine(dialog.machine, {
		id: 'dialog',
	});
	let api = track(() => dialog.connect(service, normalizeProps));

	<button {...@api.getTriggerProps()}>{'Open Dialog'}</button>
	<Portal target={document.body}>
		<div {...@api.getBackdropProps()} />
		<div {...@api.getPositionerProps()}>
			<div {...@api.getContentProps()}>
				<h2 {...@api.getTitleProps()}>{'Edit profile'}</h2>
				<p {...@api.getDescriptionProps()}>
					{'Make changes to your profile here. Click save when you are done.'}
				</p>

				<div>
					<input placeholder="Enter name..." />
					<button>{'Save'}</button>
				</div>
				<button {...@api.getCloseTriggerProps()}>
					<X />
				</button>
			</div>
		</div>
	</Portal>
}
